import { create } from "zustand";

import { TCountry } from "@type/api/user/types";

type TCountryStore = {
  countries?: TCountry[];
  loadingCountry: boolean;
  onSetCountry: (countries: TCountry[]) => void;
  onSetLoadingCountry: (loadingCountry: boolean) => void;
};

export const useCountryStore = create<TCountryStore>((set) => ({
  countries: undefined,
  loadingCountry: false,
  onSetCountry: (countries) => {
    set({ countries });
  },
  onSetLoadingCountry: (loadingCountry) => {
    set({ loadingCountry });
  },
}));
